export default __webpack_public_path__ + "locales/sq-AL/FormGallery.json?hash=927e863dadc55688074d65a2fe29bcb2";